// StatsSidebar.js

import React, { useState } from 'react';
import { useChat } from './ChatContext';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';

const StatsSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { overallRating, remainingRequests } = useChat();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`stats-sidebar ${isOpen ? 'stats-sidebar-open' : 'stats-sidebar-closed'}`}>
      <button 
        className="sidebar-toggle-button" 
        onClick={toggleSidebar}
        aria-label={isOpen ? "Close stats sidebar" : "Open stats sidebar"}
      >
        {isOpen ? <FaChevronLeft /> : <FaChevronRight />}
      </button>
      
      <div className="sidebar-content">
        <div className="stat-box">
          <span className="stat-label">Overall Rating</span>
          <span className="stat-value">{overallRating}</span>
        </div>
        <div className="stat-box">
          <span className="stat-label">Number of Convos</span>
          <span className="stat-value">{remainingRequests || 0}</span>
        </div>
      </div>
    </div>
  );
};

export default StatsSidebar;
